import styled from "styled-components";
import GlobalTheme from "./styles/global.theme";
import screenSize from "./styles/mediaQueries";

import { IoIosHelpCircle } from "react-icons/io";
import { MdInfo } from "react-icons/md";
import { IoClose } from "react-icons/io5";

// remove
import { Container, Checkbox } from "@mui/material";
import { Box } from "@mui/system";

export const MaxWidth = styled.div`
    margin: 0 auto;
    max-width: 1430px;

    ${screenSize.minDesktop`
    max-width: 1590px;
  `}
`;

export const WrapperDiv = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const LayoutWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
`;

export const LayoutContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
    background-color: ${GlobalTheme.palette.lightGrey.primary.main};
    color: white;
    padding: 0;
    text-align: center;
    height: 100vh;
    position: relative;
`;

export const CustomInfoText = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${GlobalTheme.palette.lightGrey.primary.main};
    ${(props) =>
        props.bold &&
        ` font-weight: bold;
    `}
`;

// ::: NAVBAR :::
export const NavbarWrapper = styled.div`
    background-color: ${GlobalTheme.palette.purple.primary.darker};
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 100;
`;

export const NavAppBar = styled.div`
    position: "static";
    background-color: ${GlobalTheme.palette.white.primary.main};
    color: ${GlobalTheme.palette.black.primary.main};
    height: 80px;
`;

export const NavBarBox = styled.div`
  display: "flex",
  alignItems: "center",
  z-index: 0,
`;

export const NavbarButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

// ::: LOGO :::
export const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
`;

export const StyledLogo = styled.img`
    height: 65px;
    width: auto;
    padding: 10px;

    @media (min-width: 1024px) {
        display: none;
    }
`;

export const CustomLogo = styled.img`
    height: 75px;
    width: auto;
    padding: 10px;
`;

// ::: ERROR MESSAGE :::
export const ErrorMessageWrapper = styled.div`
    margin-top: 20px;
`;

export const ErrorMessage = styled.p`
    font-size: 16px;
    color: ${GlobalTheme.palette.pink.primary.main};
    font-weight: ${GlobalTheme.typography.fontWeightRegular};
    margin: ${(props) => props.margin || "0"};
`;

// ::: TITLES, BODY TEXT, LINK :::
export const MainTitleArrowWrapper = styled.div`
    width: ${(props) => props.margin || "70%"};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 0 0;
`;

export const MainTitle = styled.h1`
    font-size: 28px;
    color: ${GlobalTheme.palette.black.primary};
    font-weight: ${GlobalTheme.typography.fontWeightLight};
    text-align: center;
    flex-grow: 1;
    margin: ${(props) => props.margin || "0"};
`;

export const SubTitle = styled.h3`
    font-size: 24px;
    color: ${GlobalTheme.palette.black.primary};
    font-weight: ${GlobalTheme.typography.fontWeightLight};
`;

export const BodyText = styled.p`
    width: 100%;
    font-size: ${(props) => props.fontSize || "18px"};
    color: ${GlobalTheme.palette.black.primary};
    line-height: ${(props) => props.lineHeight || "1.3"};
    font-weight: ${(props) => props.fontWeight || "normal"};
    font-style: ${(props) => props.fontStyle || "normal"};
    text-align: ${(props) => props.textAlign};
    margin: ${(props) => props.margin || "0"};
    ${screenSize.minDesktop`
    width: 60%;
  `}
`;

export const StyledTag = styled.span`
    background-color: ${GlobalTheme.palette.purple.primary.main};
    color: ${GlobalTheme.palette.white.primary.main};
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: ${GlobalTheme.typography.fontWeightMedium};
`;

export const StyledLink = styled.a`
  color: ${GlobalTheme.palette.purple.primary.main}
  text-decoration: none; 
  font-weight:400;
  font-size: 18px; 
`;

// ::: DIALOG BOX :::
export const DialogBoxWrapper = styled.div`
    width: 100%;
    background-color: ${GlobalTheme.palette.white.primary.main};
    border-radius: 8px;
`;

export const DialogBoxTitleWrapper = styled.div`
    width: ${(props) => props.width};
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
`;

export const DialogBoxTitle = styled.h3`
    width: ${(props) => props.width};
    font-size: 22px;
    color: ${GlobalTheme.palette.black.primary.main};
    font-weight: ${GlobalTheme.typography.fontWeightMedium};
    text-align: ${(props) => props.textAlign};
`;

// ::: ENTRY & CODE PAGE :::
export const EntryContainer = styled.div`
    width: 100%;
    min-height: 100vh;
`;

export const EntryBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-top: 100px;
    text-align: center;
    margin-bottom: 50px;
`;

export const EntryNoteBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 90%;
    padding: 40px 25px;
    margin: 0 auto;
    border-radius: 8px;
    background-color: ${GlobalTheme.palette.purple.primary.secondary};

    ${screenSize.minDesktop`
    width: 60%;
    padding: 50px 20px;
  `};
`;

export const EntryCardBox = styled.div`
    width: 90%;
    padding: 40px;
    margin: 0 auto;
    border-radius: 8px;
    background-color: ${GlobalTheme.palette.white.primary.main};
    border: ${(props) =>
        props.border ||
        `1px solid ${GlobalTheme.palette.grey.primary.main} !important`};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    align-items: center;

    display: flex;
    flex-direction: column;
    gap: 20px;

    ${screenSize.minLargeMobile`
    width: ${(props) => props.width || "90%"};
    padding: 50px;
  `};

    ${screenSize.minTablet`
    width: ${(props) => props.width || "60%"};
    padding: 50px;
  `};

    ${screenSize.minDesktop`
    width: ${(props) => props.width || "50%"};
    padding: 50px;
  `};

    ${screenSize.minLargeDesktop`
    width: ${(props) => props.width || "40%"};
    padding: 50px;
  `};
`;

export const OTPInputBox = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
    margin: ${(props) => props.margin};

    ${screenSize.minDesktop`
    gap: 20px;
  `};
`;

export const CodePageWrapper = styled.div`
    margin: 0 auto;
    max-width: 320px;
    margin-top: 10px;

    ${screenSize.minDesktop`
    max-width: 900px;
  `};
`;

// ::: COMPANY PAGE :::
export const CompanyFormMainWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 10px;
    @media (max-width: 320px) {
        width: 80px;
    }
    ${screenSize.minMobile`
      width: 90%;
  `}
    ${screenSize.minLargeMobile`
      width: 90%;
  `}
`;

// ::: DYNAMIC IMAGE UPLOAD :::
export const SupportedFormatWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ImageUploadedNameWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
`;

// ::: PROGRESS BAR :::
export const StyledProgressOuterBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
`;

export const ProgressInnerBox = styled.div`
    margin-bottom: 45px;
    margin-left: -35px;
    font-size: 20px;
    display: flex;
    align-items: center;
    color: ${GlobalTheme.palette.black.primary.main};
`;

export const ProgressBarMainWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 100px;
`;

// ::: TRADING ADDRESS :::
export const TradingTitleBox = styled.div`
    margin-top: -30px;
    margin-left: -40px;
    padding: 8px 16px;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: relative;
    @media (max-width: 320px) {
        width: 100%;
        padding: 10px;
        margin-left: 0;
    }
    @media (max-width: 640px) {
        width: 100%;
        margin-left: 0;
    }
    ${screenSize.minDesktop`
       width: 100%;
      padding: 10px;
  `}
`;

export const TradingAddressBox = styled.div`
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    padding: 20px;
    border-radius: 8px;

    background-color: ${GlobalTheme.palette.white.primary.main};
    border: ${(props) =>
        props.border || `1px solid ${GlobalTheme.palette.grey.primary.main}`};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);

    ${screenSize.minMobile`
    width: 380px;
    padding:50px 30px;
  `}

    ${screenSize.minTablet`
    width: 500px;
    padding:50px;
  `}

  ${screenSize.minDesktop`
      width: 600px;
      padding:50px;
  `}
`;

export const PostalBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: ${(props) => props.margin};
    width: 100%;
    gap: 20px;

    ${screenSize.minMobile`
    font-size: 14px;
    gap: 20px;
    margin-top: 10px;
  `}

    ${screenSize.minDesktop`
   font-size: 18px;
    display: flex;
     gap: 20px;
     margin-top: 0;
  `}
`;

export const StyledSpan = styled.p`
    font-size: 18px;
    color: ${GlobalTheme.palette.black.primary.darker};
    font-weight: ${GlobalTheme.typography.fontWeightMedium};
`;

export const PostalOuterDiv = styled.div`
    display: flex;
    gap: 15px;
    @media (max-width: 320px) {
        gap: 20px;
        margin-top: 15px;
    }
    ${screenSize.minMobile`
     gap: 20px;
     margin-left:10px;
     margin-top: 10px;
  `}
    ${screenSize.minTablet`
   gap: 10px;
  `}

  ${screenSize.minDesktop`
  gap: 20px;
  `}
`;

export const PostalInnerDiv = styled.div`
    display: flex;
    align-items: center;
`;

export const TradingPlacesAutocomplete = styled.p`
    color: ${GlobalTheme.palette.grey.primary.darker};
    text-align: right;
    font-size: 14px;
`;

export const TradingDropdownAddress1 = styled.p`
    color: ${GlobalTheme.palette.black.primary.main};
    font-size: 16px;
    font-weight: ${GlobalTheme.typography.fontWeightBold};
`;

export const TradingDropdownAddress2 = styled.p`
    color: ${GlobalTheme.palette.black.primary.main};
    font-size: 16px;
    font-weight: ${GlobalTheme.typography.fontWeightRegular};
`;

export const PlacesInputWrapper = styled.div`
    width: 100%;
    display: block;
`;

export const AutoPlaces = styled.div`
    width: 100%;
    display: Grid;
    flex-direction: column;
    padding-bottom: 10px;
    margin-left: -20px;
`;

export const TradingDialogWrapper = styled.div`
  background-color: ${GlobalTheme.palette.white.primary.main};
  border-radius: 8px;
  width: 100%;
  height:100%
  margin-bottom: 0;
`;

export const TradingMainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
    position: relative;
    padding-top: 80px;
    margin: 0 auto;
    width: 100%;
`;

export const AddressSection = styled.div`
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    margin-top: 30px;
`;

export const StyledContainer = styled(Container)(({ theme }) => ({
    padding: "20px",
    maxWidth: "100%",
    margin: "0 auto",
}));

// ::: REVIEW PAGE :::
export const ReviewMainWrapper = styled.div`
    background-color: ${GlobalTheme.palette.white.primary.main};
    border-radius: 8px;
    width: 100%;
    max-width: 800px;
    border: 1px solid ${GlobalTheme.palette.grey.primary.main};
    padding: 40px 50px;
    margin: ${(props) => props.margin};
`;

export const DynamicMainWrapper = styled.div`
    background-color: ${GlobalTheme.palette.white.primary.main};
    border-radius: 8px;
    width: 100%;
    max-width: 800px;
    border: 1px solid ${GlobalTheme.palette.grey.primary.main};
    padding: 40px 50px;
    margin: ${(props) => props.margin};
`;

export const ReviewCompanyRows = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 8px;
    margin: ${(props) => props.margin};
`;

export const ReviewTitleBox = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: ${(props) => props.margin};
`;

export const LogoMainBox = styled.div`
    border-top: 1px solid ${GlobalTheme.palette.grey.primary.main};
    width: 100%;
    margin: 40px auto;
    text-align: center;
`;

export const LogoReviewBox = styled.div`
    display: flex;
    justify-content: center;
    text-align: left;
    width: 50%;
`;

export const DynamicSectionMainBox = styled.div`
    width: 100%;
`;

export const DynamicSectionInnerBox = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
    margin: ${(props) => props.margin || "0"};
    padding-bottom: 30px;
    border-bottom: 1px solid ${GlobalTheme.palette.lightGrey.primary.darker};
`;

export const PaymentFormWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 10px;
    @media (max-width: 320px) {
        width: 90%;
        padding: 0;
    }
    ${screenSize.minMobile`
      width: 90%;
  `}

    ${screenSize.minLargeMobile`
      width: 90%;
  `}
`;

export const PaymentTermsCard = styled.div``;

export const PaymentTermsBody = styled.p`
    font-size: 18px;
    color: ${GlobalTheme.palette.black.primary.main};
    text-align: left;
`;

export const MarkdownContent = styled.div`
    font-size: 18px;
    color: ${GlobalTheme.palette.black.primary.main};
    text-align: left;
    line-height: 1.6;

    /* Bold text */
    strong {
        font-weight: ${GlobalTheme.typography.fontWeightBold};
        color: ${GlobalTheme.palette.black.primary.darker};
    }

    /* Headings */
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 20px 0 10px 0;
        font-weight: ${GlobalTheme.typography.fontWeightMedium};
        color: ${GlobalTheme.palette.black.primary.darker};
    }

    h1 {
        font-size: 28px;
    }
    h2 {
        font-size: 22px;
    }
    h3 {
        font-size: 20px;
    }
    h4 {
        font-size: 18px;
    }

    /* Lists */
    ul,
    ol {
        margin: 10px 0;
        padding-left: 30px;
    }

    li {
        margin: 8px 0;
        display: list-item;
        line-height: 1.6;
    }

    /* Nested lists */
    li ul,
    li ol {
        margin-top: 8px;
        margin-bottom: 8px;
    }

    li li {
        margin: 5px 0;
    }

    /* Tables */
    table {
        width: 100%;
        border-collapse: collapse;
        margin: 20px 0;
    }

    th,
    td {
        border: 1px solid ${GlobalTheme.palette.grey.primary.main};
        padding: 12px;
        text-align: left;
    }

    th {
        background-color: ${GlobalTheme.palette.lightGrey.primary.main};
        font-weight: ${GlobalTheme.typography.fontWeightBold};
    }

    /* Horizontal rules */
    hr {
        border: none;
        border-top: 1px solid ${GlobalTheme.palette.grey.primary.main};
        margin: 20px 0;
    }

    /* Paragraphs */
    p {
        font-size: 18px;
        margin: 10px 0;
    }
`;

// Payroll Terms and Conditions List
export const PayrollTandCList = styled(Box).withConfig({
    shouldForwardProp: (prop) => prop !== "item",
})`
    background-color: ${GlobalTheme.palette.lightGrey.primary.main};
    border: 1px solid ${GlobalTheme.palette.lightGrey.primary.darker};
    border-radius: ${(props) => props.borderRadius || "8px"};
    padding: 50px;
    margin-bottom: 50px;
    position: relative;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    &:nth-child(odd) {
        background-color: ${GlobalTheme.palette.purple.primary.lighter};
    }

    &:nth-child(even) {
        background-color: ${GlobalTheme.palette.orange.primary.lighter};
    }
`;

// Terms and Condition Container
export const TermsConditionContainer = styled.div`
    // display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
`;

// Payroll Main Container
export const PayrolMainContainer = styled(Container)`
  display: flex,
  justify-content: center,
  align-items: center;,
  height: 100vh,
  width: 100%,

  @media (max-width: 576px) {
    display: flex,
    justify-content: center,
    align-items: center,
    height: 100vh,
    padding: 0,
  }
`;

export const ToogleOuterContainer = styled.div`
    margin-top: 20px;
    display: flex;
    margin-left: 0;
    margin-right: 0;
    justify-content: center;
    align-items: center;
    width: 90%;
    padding: 60px;
`;

export const ToggleContainer = styled.div`
    display: flex;
    width: 300px;
    background-color: ${GlobalTheme.palette.purple.primary.main};
    border: 2px solid ${GlobalTheme.palette.purple.primary.main};
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 30px;
    justify-content: center;
`;

export const ToggleOption = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== "isActive",
})`
    flex: 1;
    padding: 10px;
    text-align: center;
    font-size: 18px;
    border-radius: 8px;
    cursor: pointer;
    background-color: ${(props) =>
        props.isActive
            ? GlobalTheme.palette.white.primary.main
            : GlobalTheme.palette.purple.primary.main};
    color: ${(props) =>
        props.isActive
            ? GlobalTheme.palette.purple.primary.main
            : GlobalTheme.palette.white.primary.main};

    &:last-child {
        border-right: none;
    }
`;

export const MainWrapper = styled.div`
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const AuthorisedMainWrapper = styled.div`
    width: "100%";
    background-color: ${GlobalTheme.palette.white.primary.main};
    border-radius: "8px";
    border: 1px solid ${GlobalTheme.palette.lightGrey.primary.darker};
    boxshadow: "0px 4px 8px rgba(0, 0, 0, 0.1)";
`;

export const AuthorisedTextfield = styled(Container)({
    "&::placeholder": {
        fontWeight: "bold",
        fontSize: 16,
    },
});

export const ProgressBarContainerWrapper = styled.div`
    position: relative;
    margin-bottom: 0;
    z-index: 0;
    margin-top: 70px;
    display: block;
`;

export const CardMainWrapper = styled.div`
    background-color: ${GlobalTheme.palette.white.primary.main};
    border-radius: 1;
    width: "100%";
    maxwidth: "800px";
    border: 1px solid ${GlobalTheme.palette.lightGrey.primary.darker};
    padding: "20px";
    marginbottom: "20px";
    position: "relative";
    margintop: "20px";
`;

export const OuterMainDiv = styled.div`
    display: flex;
    width: 100%;
    gap: 40px !important;
    margin-top: 20px !important;
    @media (max-width: 320px) {
        gap: 30px !important;
        flex-direction: column;
    }
    ${screenSize.minMobile`
    gap: 10px !important;
    flex-direction: column;
    gap: 30px !important;
  `}
    ${screenSize.minTablet`
    gap: 30px !important;
    margin-left: -1px;
    margin-right: -1px;
     flex-direction: row;
 
  `}
  ${screenSize.minLargeDesktop`
    gap: 40px !important;
    margin-left: -1px;
    margin-right: -1px;
    flex-direction: row;
 
  `}
`;
export const OuterDiv = styled.div`
    display: flex !important;
    gap: 40px !important;
    align-items: center;
    margin-top: 20px !important;
    @media (max-width: 320px) {
        gap: 10px !important;
        margin-left: -20px;
        margin-right: -20px;
    }
    ${screenSize.minMobile`
    gap: 10px !important;
    margin-left: -20px;
    margin-right: -20px;
  `}
    ${screenSize.minLargeDesktop`
    gap: 30px !important;
    margin-left: -1px;
    margin-right: -1px;
   
  `}
`;
export const InnerDiv = styled.div`
    flex: 1;
`;
export const FieldDiv = styled.div`
    margin-bottom: "20px";
`;

export const MainDiv = styled.div`
    width: "100%";
    background-color: ${GlobalTheme.palette.white.primary.darker};
    border-radius: "8px";
    border: 1px solid ${GlobalTheme.palette.lightGrey.primary.main};
    boxshadow: "0px 4px 8px rgba(0, 0, 0, 0.1)";
    position: "relative";
`;

export const StyledErrorBox = styled.div`
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 16px;
    background-color: ${GlobalTheme.palette.lightGrey.primary.main};
    border-radius: 8px;
`;

export const DynamicCardMainWrapper = styled.div`
    background-color: ${GlobalTheme.palette.white.primary.main};
    border-radius: 8px;
    width: 90%;
    border: 1px solid ${GlobalTheme.palette.grey.primary.main};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 50px;
    margin: 0 0 20px 0;
`;

export const CustomTitleBox = styled.div`
    padding: 50px;
    color: ${GlobalTheme.palette.black.primary.main};

    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    ${screenSize.minMobile`
    padding: 15px;
  `}

    ${screenSize.minLargeMobile`
   padding: 15px;
  `}
    ${screenSize.minTablet`
    padding:35px;
  `}

  ${screenSize.minDesktop`
    padding:40px;
  `}
`;

export const DynamicCardTitleBox = styled.div`
    color: ${GlobalTheme.palette.black.primary.main};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const DataBox = styled.div`
    margin-top: 20px;
    text-align: left;
    padding: 5px;
    @media (max-width: 320px) {
        padding: 5px;
        margin-left: 10px;
    }
    ${screenSize.minMobile`
    margin-left: 10px;
  `}
    ${screenSize.minDesktop`
   margin-left: 30px;
  `}
`;

export const StyledImage = styled.img`
    width: 200px;
    height: auto;
    border-radius: 8px;
    object-fit: cover;
`;
export const ShowImageBox = styled.div`
    width: 100%;
    padding: 20px;
    text-align: center;
`;

export const ShowImageInnerBox = styled.div`
    margintop: "20px";
    textalign: "center";
`;

export const ShowNoImageBox = styled.div`
    background-color: ${GlobalTheme.palette.lightGrey.primary.main};
    color: ${GlobalTheme.palette.black.primary.main};
    width: auto;
    max-width: 250px;
    min-height: 60px;
    padding: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ImageMainWrapper = styled.div`
    width: 100%;
`;

export const ReviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    padding: 70px;
    width: 100%;

    @media (max-width: 320px) {
        width: 100%;
        padding-top: 50px;
    }
    ${screenSize.minMobile`
    width: 95%;
    padding: 10px;
  `}

    ${screenSize.minLargeMobile`
    width: 95%;
    padding: 10px;
  `}
    ${screenSize.minLargeDesktop`
      width: 100%;
      padding: 20px;
  `}
`;

export const CustomReviewInnerContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: left;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    text-align: left;
    overflow: hidden;
    border-radius: 8px;
`;

export const CustomSubmitContainer = styled.div`
    padding-top: 40px;
    display: flex;
    justify-content: center;
    text-align: left;
    max-width: 900px;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
`;

export const StyledCheckbox = styled(Checkbox)`
    color: ${GlobalTheme.palette.grey.primary.main} !important;

    &.Mui-checked {
        color: ${GlobalTheme.palette.purple.primary
            .main} !important; // Color when checked
    }
    .MuiCheckbox-root {
        padding: 6px;
    }
`;

export const CheckboxLabel = styled.span`
    color: #444248;
    font-size: 18px;
    margin: ${(props) => props.margin};
`;

export const NavMainWrapper = styled.div`
    flex-grow: 1;
`;

export const PaymentFormContainer = styled.div`
    margin-top: 20px;
    display: flex;
    margin-left: 0;
    margin-right: 0;
    justify-content: center;
    align-items: center;
    width: 90%;
    padding: 60px;
    textalign: center;
    background-color: ${GlobalTheme.palette.white.primary.main};
    border-radius: ${(props) => props.borderRadius || "8px"};
    border: ${(props) =>
        props.border ||
        `1px solid ${GlobalTheme.palette.grey.primary.main} !important`};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    @media (max-width: 320px) {
        padding: 30px 15px;
    }
    ${screenSize.minMobile`
      padding: 30px 15px;
  `}

    ${screenSize.minLargeMobile`
      padding: 30px 15px;
  `}

  ${screenSize.minTablet`
      padding: 50px 35px;
  `}

  ${screenSize.minDesktop`
      padding: 50px 35px;
  `}
`;

export const CompanyLogoContainer = styled.div`
    margin: 60px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    padding: 40px;
    textalign: center;
    background-color: ${GlobalTheme.palette.white.primary.main};
    border-radius: ${(props) => props.borderRadius || "8px"};
    border: ${(props) =>
        props.border ||
        `1px solid ${GlobalTheme.palette.grey.primary.main} !important`};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    @media (max-width: 320px) {
        margin: 50px 0;
        width: 90%;
        padding: 30px;
    }

    ${screenSize.minMobile`
    margin: 50px 0;
    padding: 30px;
    width: 100%;
  `}

    ${screenSize.minLargeMobile`
    margin: 30px 0;
    padding: 30px;
     width: 100%;
  `}

  ${screenSize.minTablet`
    margin: 30px 0;
    padding: 30px;
    width: 90%;
  `}

  ${screenSize.minDesktop`
    margin: 60px 0;
    padding: 40px;
    width: 90%;
  `}
`;

export const StyledHelpIcon = styled(IoIosHelpCircle)`
    color: ${GlobalTheme.palette.purple.primary.main};
    margin-top: 0;
    font-size: 22px !important;
    line-height: 0;
`;

export const StyledInfo = styled(MdInfo)`
    color: ${GlobalTheme.palette.purple.primary.main};
    margin-top: 0;
    font-size: 22px !important;
    line-height: 0;
`;

export const StyledCloseIcon = styled(IoClose)`
    color: ${GlobalTheme.palette.black.primary.main};
    cursor: pointer;
    font-size: 22px !important;
    line-height: 0;
`;

export const TradingDialogMainWrapper = styled.div`
  width: ${(props) => props.width || "100%"};
  background-color: ${(props) =>
      props.backgroundColor || GlobalTheme.palette.white.primary.main}};
  border-radius: ${(props) => props.borderRadius || "8px"};
  border: ${(props) =>
      props.border ||
      `1px solid ${GlobalTheme.palette.lightGrey.primary.darker}`};
  box-shadow: ${(props) => props.boxShadow || "0px 4px 8px rgba(0, 0, 0, 0.1)"};
`;

export const InnerField = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 20px;
`;
export const StyledLabel = styled.label`
    font-size: 16px;
    color: ${GlobalTheme.palette.black.primary.darker};
    font-weight: ${GlobalTheme.typography.fontWeightBold};
    margin-top: 3px;
    margin-left: 10px;
    cursor: pointer;
`;

export const AuthorisedDiv = styled.div`
    background-color: ${GlobalTheme.palette.purple.primary.secondary};
    border: 1px solid ${GlobalTheme.palette.grey.primary.main};
    border-radius: 8px;
    width: 90%;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const AdditionDetailBox = styled.div`
    color: ${GlobalTheme.palette.black.primary.darker};
    font-size: ${(props) => props.fontSize};
    padding: 24px 20px 20px 20px;
    background-color: ${GlobalTheme.palette.purple.primary.secondary};
    border-radius: 8px;
    width: 100%;

    @media (max-width: 320px) {
        width: 95%;
    }
    ${screenSize.minLargeMobile`
      width: 95%;
  `}
    ${screenSize.minTablet`
      width: 90%;
  `}
  ${screenSize.minDesktop`
      width: 90%;
  `}
`;

export const AdditionDetailLink = styled.a`
    font-size: ${(props) => props.fontSize};
    color: ${GlobalTheme.palette.purple.primary.main};
    text-decoration: none;
    font-weight: 600;
    cursor: pointer;
`;

export const InputButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: ${(props) => props.width || "100%"};
    border-radius: 8px;
    background-color: ${GlobalTheme.palette.white.primary.main};
    border: ${(props) =>
        props.border ||
        `1px solid ${GlobalTheme.palette.grey.primary.main} !important`};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    align-items: center;
    margin: ${(props) => props.margin};
    padding: 40px;
`;

export const TimelineWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 300px;
    height: 100vh;
    z-index: 101;
    background-color: ${GlobalTheme.palette.purple.primary.main};
    overflow-y: auto;
    @media (max-width: 768px) {
        display: none;
    }
    @media (max-width: 1024px) {
        width: 250px;
    }
`;

export const ContentWrapper = styled.div`
    margin-left: 300px;
    display: flex;
    flex-direction: column;
    width: calc(100% - 300px);
    height: 100vh;
    @media (max-width: 1024px) {
        margin-left: 250px;
        width: calc(100% - 250px);
    }
    @media (max-width: 768px) {
        margin-left: 0;
        width: 100%;
    }
`;
export const BodyWrapper = styled.div`
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 80px);
    border-top: 2px solid ${GlobalTheme.palette.lightGrey.primary.darker};
    margin-top: 80px;
`;

export const ButtonWrapper = styled.div`
    position: relative;
    z-index: 10;
`;

export const TimelineLogo = styled.img`
    height: 60px;
    width: 130px;
    margin-bottom: 50px;
    margin-left: -50px;
    margin-top: 10px;
    left: 20px;
    gap: 64px;
`;

export const AcknowledgementBox = styled.div`
    background-color: ${GlobalTheme.palette.purple.primary.lighter};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    position: relative;
    width: 90%;
    padding: 40px;
    margin: ${(props) => props.margin};

    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

// ::: CONTACT PAGE :::
export const ContactFormWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 10px;
    gap: 40px;

    ${screenSize.minDesktop`
      flex-direction: row;
  `}
`;

export const ContactFormFieldsWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;

    ${screenSize.minDesktop`
      width: 70%;
  `}
`;

export const ContactCheckboxWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    ${screenSize.minDesktop`
      width: 30%;
  `}
`;

export const ContactCardTitle = styled.p`
    font-size: ${(props) => props.fontSize};
    font-weight: 600;
    color: ${GlobalTheme.palette.black.primary.dark};
    span {
        font-size: 16px;
        font-weight: 400;
        font-style: italic;
    }
`;

export const ContactFormRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
`;

export const ContactRemoveLink = styled.a`
    font-size: 16px;
    color: ${GlobalTheme.palette.pink.primary.main};
    text-decoration: none;
    font-weight: 400;
    cursor: pointer;

    display: flex;
    flex-direction: row;
    align-self: flex-end;
    align-items: center;
    gap: 10px;
`;

export const ContactFormSeparator = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${GlobalTheme.palette.grey.primary.main};
    margin: 30px 0 20px 0;
`;

// ::: CONTACT TYPE TAGS :::
export const ContactNameTagsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

    ${screenSize.minTablet`
        flex-direction: row;
        align-items: center;
        gap: 15px;
    `}
`;

export const ContactTagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
`;

export const ContactTypeTag = styled.span.withConfig({
    shouldForwardProp: (prop) => prop !== "isPrimary",
})`
    background-color: ${(props) =>
        props.isPrimary
            ? GlobalTheme.palette.grey.primary.darker
            : GlobalTheme.palette.grey.primary.main};
    color: ${(props) =>
        props.isPrimary ? GlobalTheme.palette.white.primary.main : "#333"};
    padding: 6px 12px 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: ${GlobalTheme.typography.fontWeightRegular};
    white-space: nowrap;
`;

// ::: THANK YOU PAGE :::
export const ThankyouCopy = styled.p`
    font-size: 18px;
    font-weight: 400;
    color: ${GlobalTheme.palette.black.primary.dark};
    a {
        color: ${GlobalTheme.palette.purple.primary.main};
        font-size: 18px;
        text-decoration: none;
        font-weight: 400;
        cursor: pointer;
    }
`;
